import { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';

const InteractiveMapMapbox = lazy(() =>
  import('../InteractiveMap/index.mapbox')
);
const InteractiveMapGoogle = lazy(() => import('../InteractiveMap'));

const SliderTrackMap = props => {
  const mapProviderVariant = useSoyuzExperiment('MapProvider').get('behaviour');
  const InteractiveMap =
    mapProviderVariant === 'mapbox'
      ? InteractiveMapMapbox
      : InteractiveMapGoogle;

  return (
    <Suspense fallback={null}>
      <InteractiveMap {...props.item} mapId="slider-map" />
    </Suspense>
  );
};

SliderTrackMap.propTypes = {
  item: PropTypes.shape({
    coords: PropTypes.arrayOf(PropTypes.number),
    countryCode: PropTypes.string,
    areaSlug: PropTypes.string
  }).isRequired
};

export default SliderTrackMap;
